const API_V1 = '/api/v1';

export const ENDPOINTS = {
  captivePolicies: `${API_V1}/captive-policies`,
  certificates: `${API_V1}/certificates`,
  certificatesSearch: `${API_V1}/certificates/search`,
  certificate: (id: string) => `${API_V1}/certificates/${encodeURIComponent(id)}`,
  certificateRenewalRequest: (id: string) =>
    `${API_V1}/certificates/${encodeURIComponent(id)}/renewal-request`,
  certificateTemplatesByCountry: (countryCode: string) =>
    `${API_V1}/certificate-templates/country/${encodeURIComponent(countryCode)}`,
  countries: `${API_V1}/countries`,
  countryAssureds: `${API_V1}/country-assureds/all`,
  currentUser: `${API_V1}/external-users/me`,
  locationLimits: `${API_V1}/sub-policies/location-limits`,
} as const;
